var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'donor-my-contact-list' || _vm.$route.name === 'donor-my-team-contact-list')?_c('div',{staticClass:"tw-relative tw-block md:tw-hidden"},[_vm._v(" "+_vm._s(_vm.$route.name)+" "),_c('div',{staticClass:"clip-bottom-round tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-[70vh] tw-bg-[var(--my-primary)] tw-z-[1]"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }